import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES } from "../../data/content";

export const Experience = () => (
  <section
    id="experiencia"
    data-testid="experience-section"
    className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36"
  >
    <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16 md:mb-24">
      <div className="lg:col-span-7">
        <Reveal>
          <div className="eyebrow text-accent mb-5">La experiencia Hydra Power</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-ink leading-[0.95] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
            Un spa para tus pies,
            <br />
            <span className="italic text-brand-soft">cada noche en casa</span>
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-5">
        <Reveal delay={0.2}>
          <p className="text-base md:text-lg text-ink/70 leading-relaxed">
            Nacimos de un ritual sencillo: cuidar la parte del cuerpo que más
            trabaja y menos atención recibe. Cada fórmula combina ciencia
            dermatológica con ingredientes botánicos cultivados de forma
            responsable.
          </p>
        </Reveal>
      </div>
    </div>

    <div className="grid md:grid-cols-2 gap-6 md:gap-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-2xl group aspect-[4/5] md:aspect-[16/12]">
          <motion.img
            src={IMAGES.spa}
            alt="Ambiente spa natural"
            className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
          <div className="absolute bottom-0 p-8 text-white">
            <div className="font-serif text-3xl md:text-4xl">Frescura botánica</div>
            <p className="text-sm text-white/80 mt-2 max-w-sm">
              Menta, aloe y aceites esenciales que despiertan tus sentidos.
            </p>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.12}>
        <div className="relative overflow-hidden rounded-2xl group aspect-[4/5] md:aspect-[16/12]">
          <motion.img
            src={IMAGES.jars}
            alt="Frascos de crema con hojas verdes"
            className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-transparent" />
          <div className="absolute bottom-0 p-8 text-white">
            <div className="font-serif text-3xl md:text-4xl">Fórmula limpia</div>
            <p className="text-sm text-white/80 mt-2 max-w-sm">
              Sin parabenos ni siliconas. Cruelty-free y de origen natural.
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
